import axios from "@/axios/axios";

const PROJECT = "urbo";

const META_EVENTS = {
  view_content: { name: "ViewContent", type: "standard" },
  generate_lead: { name: "Lead", type: "standard" },
  contact_form_open: { name: "Contact", type: "standard" },
  phone_click: { name: "Contact", type: "standard" },
  email_click: { name: "Contact", type: "standard" },
  house_detail_click: { name: "house_detail_click", type: "custom" },
  theupside_project_click: { name: "theupside_project_click", type: "custom" },
};

export const createEventId = (eventName) => [
  PROJECT,
  eventName,
  Date.now(),
  Math.random().toString(36).slice(2, 10),
].join("_");

const getCookie = (name) => {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
};

const getFacebookClickCookie = () => {
  const existing = getCookie("_fbc");
  if (existing) return existing;

  const fbclid = new URLSearchParams(window.location.search).get("fbclid");
  if (!fbclid) return null;

  return `fb.1.${Date.now()}.${fbclid}`;
};

const getPageType = () => {
  const path = window.location.pathname;

  if (path.includes("/p/inzerat/")) return "ad_detail";
  if (path.includes("/p/inzeraty")) return "ads_list";
  if (path.includes("/p/projekty")) return "projects";
  if (path.includes("/p/o-nas")) return "about";

  return "home";
};

const cleanText = (value) => String(value || "").replace(/\s+/g, " ").trim();

const getCommonParams = () => ({
  project: PROJECT,
  site_context: "urbo",
  site_hostname: window.location.hostname,
  page_type: getPageType(),
  page_path: window.location.pathname,
  page_location: window.location.href,
});

export const getAdvertisementTrackingParams = (advertisement) => {
  if (!advertisement) return {};
  const baseProperty = advertisement.base_property || {};
  const adProject = baseProperty.project;

  return {
    ad_id: advertisement.id,
    ad_title: advertisement.title || advertisement.name,
    ad_resource_type: baseProperty.resourcetype,
    ad_project_id: typeof adProject === "object" ? adProject?.id : adProject,
    ad_project_name: typeof adProject === "object" ? adProject?.name : baseProperty.project_name,
    ad_price: advertisement.inzerovana_cena,
  };
};

export const getFacebookBrowserPayload = (eventName) => {
  if (typeof window === "undefined") return {};

  const consent = window.URBOPrivacy?.get();
  if (!consent?.marketing) return {meta_marketing_consent: false};
  return {
    meta_marketing_consent: true,
    meta_consent_version: consent.version,
    meta_consent_timestamp: consent.timestamp,
    meta_event_id: createEventId(eventName),
    meta_fbp: getCookie("_fbp"),
    meta_fbc: getFacebookClickCookie(),
    meta_event_source_url: window.location.href,
  };
};

export const trackEvent = (eventName, params = {}) => {
  if (typeof window === "undefined" || !eventName) return;

  const metaEvent = META_EVENTS[eventName] || { name: eventName, type: "custom" };
  const eventId = params.event_id || createEventId(eventName);

  window.URBOPrivacy?.track(eventName, {
    ...getCommonParams(), ...params,
  }, metaEvent, eventId);
  return eventId;
};

const getCampaignParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const keys = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gclid",
    "fbclid",
  ];
  const campaign = {};

  keys.forEach((key) => {
    const value = searchParams.get(key);
    if (value) campaign[key] = value;
  });

  return campaign;
};

export const trackAdvertisementView = async (advertisementId) => {
  if (typeof window === "undefined" || !advertisementId || !window.URBOPrivacy?.get()?.analytics) return;

  try {
    await axios.post(`/advertisement/${advertisementId}/track-view/`, {
      source: PROJECT,
      path: window.location.pathname + window.location.search,
      url: window.location.href,
      referrer: document.referrer || null,
      campaign: getCampaignParams(),
    });
  } catch {
    // Tracking nesmie rozbiť verejný detail inzerátu.
  }
};

export const installClickTracking = () => {
  if (typeof document === "undefined") return;

  document.addEventListener("click", (event) => {
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest("a[href]");
    if (!link) return;

    const href = link.getAttribute("href") || "";
    const text = cleanText(link.textContent);

    if (href.startsWith("tel:")) {
      trackEvent("phone_click", {
        click_text: text,
        click_url: href,
        click_placement: getPageType(),
      });
    }

    if (href.startsWith("mailto:")) {
      trackEvent("email_click", {
        click_text: text,
        click_url: href,
        click_placement: getPageType(),
      });
    }

    try {
      const url = new URL(href, window.location.href);
      if (url.hostname.replace(/^www\./, "") === "theupside.sk") {
        trackEvent("theupside_project_click", {
          click_text: text,
          click_url: url.href,
          click_placement: getPageType(),
        });
      }
    } catch {
      // Relative and malformed URLs are ignored for external project tracking.
    }
  });
};
